module.exports = __webpack_public_path__ + "img/personalized-learning.d45e62b8.svg";